import templateUrl from "emun.invoice/credit-request/credit-request-details.htm";
import controller from "emun.invoice/credit-request/credit-request-details.controller";

export default {
  bindings: {
    creditRequestId: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
